import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import AssessmentRiskLevelChart from 'on_web/components/shared/AssessmentRiskLevelChart/AssessmentRiskLevelChart';

export default function TraitRisk(props) {
  const useStyles = makeStyles(theme => ({
    riskLevel: {
      fontSize: '25px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
    },
  }));

  const classes = useStyles();

  return (
    <Box justifyContent="center" display="flex">
      <Grid container direction="column" justify="center" alignItems="center">
        <Grid item>
          <AssessmentRiskLevelChart
            riskLevel={props.riskLevel}
            showLabels={props.showLabels}
            width={props.width ? props.width : 300}
          />
        </Grid>
        <Grid item style={{ marginTop: '20px' }}>
          <Box className={classes.riskLevel}>{props.riskLabel}</Box>
        </Grid>
      </Grid>
    </Box>
  );
}
